<script setup lang="ts">
import type { GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables } from './UsersSelector.generated'
import { Role, UsersType } from '~/codegen/graphql'
import { GetOrganizationMembersDocument } from './UsersSelector.generated'

const {
  multiple = true,
  showContributors,
} = defineProps<{
  multiple?: boolean
  showContributors?: boolean
}>()

const selectedUsers = defineModel<string[] | string>({ required: true })
const { isFetching, search } = useRelayField<
  GetOrganizationMembersQuery,
  GetOrganizationMembersQueryVariables,
  SelectMenuOption[]
>(
  GetOrganizationMembersDocument,
  computed(() => ({
    first: 50,
    term: '',
    existing: selectedUsers.value,
    userType: showContributors ? UsersType.All : undefined,
  })),
  ({ data }) => getListOfNodes(data?.organization.users).map(node =>
    ({
      label: `${node.display}${node.display === node.email || !node.email ? '' : ` (${node.email})`}${node.role === Role.Contributor ? ' - Contributor' : ''}`,
      value: node.id,
      avatar: { src: node.gravatar },
    }),
  ),
)
</script>

<template>
  <SelectMenu
    v-model="selectedUsers"
    :is-fetching="isFetching"
    :leading-icon="multiple ? 'light:magnifying-glass' : undefined"
    :placeholder="`Select ${multiple ? 'users' : 'a user'}`"
    :searchable="search"
    option-attribute="label"
    value-attribute="value"
    selected-icon="light:check"
    :multiple="multiple"
    trailing
  />
</template>
